<div class="row">
    <div class="col-sm-9 form-inline">
        <div class="row student-edition">
            <div class="form-group col-sm-4" style="margin-left: -4px;">
                <input auto-complete
                       [(ngModel)]="tsStudent.email"
                       [source]="students.bind(this)"
                       type="email"
                       id="studentMail"
                       name="studentMail"
                       [list-formatter]="studentListFormatter"
                       [min-chars]="3"
                       autocomplete="on"
                       [accept-user-input]="true"
                       display-property-name="email"
                       (valueChanged)="changeStudent($event)"
                       placeholder="E-mail"
                       #studentInput="ngModel"
                       class="form-control input-sm">
            </div>
            <div class="form-group col-sm-4">
                <input [(ngModel)]="tsStudent.lastName" type="text" id="studentLName"
                       name="studentLName" placeholder="Nom"
                       class="form-control input-sm">
            </div>
            <div class="form-group col-sm-4">
                <input [(ngModel)]="tsStudent.firstName" type="text" id="studentFName"
                       name="studentFName" placeholder="Prénom"
                       class="form-control input-sm">
            </div>
        </div>
    </div>
    <div class="col-sm-3 btn-group-sm text-right" style="padding-right: 9px;">
        <button class="btn btn-primary" style="margin-bottom: 4px;" [disabled]="isDisabled()" (click)="save(tsStudent)">
            <span *ngIf="!saving" class="fa fa-fw fa-check"></span>
            <span *ngIf="saving" class="fa fa-spinner fa-spin"></span>
        </button>
        <button class="btn btn-default" style="margin-bottom: 4px;" [disabled]="saving" (click)="cancel(tsStudent)">
            <span class="fa fa-fw fa-ban"></span>
        </button>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/registration-company/registration-contact/registration-student/student-edition/student-edition.component.html